import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class PasswordConfirmationValidatorService {

  constructor() { }

  public validateMatch(matchTo: string, reverse?: boolean): ValidatorFn {
    return (control: AbstractControl):ValidationErrors | null => {
      if (control.parent && reverse) {
        const c = (control.parent?.controls as any)[matchTo]as AbstractControl;
        if (c) {
          c.updateValueAndValidity();
        }
        return null;
      }
      return !!control.parent && !!control.parent.value && control.value === (control.parent?.controls as any)[matchTo].value? null: { matching: true }
    }
  }

  public validateConfirmPassword(passwordControl: AbstractControl): ValidatorFn {
    return (confirmationControl: AbstractControl): { [key: string]: boolean } | null => {
      const confirmValue = confirmationControl.value;
      const passwordValue = passwordControl.value;
      if (confirmValue === '') {
        return;
      }
      if (confirmValue !== passwordValue) {
        return { mustMatch: true }
      }
      return null;
    };
  }
}
